(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Apparition au scroll */
  var items = [].slice.call(document.querySelectorAll('[data-vx-reveal]'));
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    items.forEach(function (el) { io.observe(el); });
  } else {
    root.classList.remove('vx-js');
  }
  document.addEventListener('shopify:section:load', function (event) {
    [].slice.call(event.target.querySelectorAll('[data-vx-reveal]')).forEach(function (el) {
      el.classList.add('is-visible');
    });
  });

  /* Léger mouvement du produit au défilement (très discret) */
  var para = [].slice.call(document.querySelectorAll('[data-vx-parallax]'));
  if (para.length && !reduce) {
    var ticking = false;
    var update = function () {
      ticking = false;
      var y = window.scrollY || 0;
      if (y > 1600) return;
      para.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-vx-parallax')) || 0.04;
        el.style.transform = 'translate3d(0,' + (y * speed).toFixed(1) + 'px,0)';
      });
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
  }

  /* Panneau des caractéristiques (fiche produit) */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('a[href="#caracteristiques"]');
    if (trigger) {
      var dialog = document.getElementById('vx-specs');
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
        document.body.style.overflow = 'hidden';
      }
      return;
    }
    if (event.target.closest && event.target.closest('[data-vx-close-specs]')) {
      var open = document.getElementById('vx-specs');
      if (open) open.close();
      return;
    }
    if (event.target.id === 'vx-specs') event.target.close();
  });
  document.addEventListener('close', function (event) {
    if (event.target && event.target.id === 'vx-specs') document.body.style.overflow = '';
  }, true);
})();
